import { createAction, createSlice } from "@reduxjs/toolkit";
// import courseInfo from "./courseInfo.json";

const getDetailsCourseSlice = createSlice({
  name: "getDetailsCourse",
  initialState: { data: null, processing: false },
  reducers: {
    pending(state) {
      state.processing = true;
      /* TODO: reducer for pending*/
    },
    success(state, action) {
      state.processing = false;
      /* TODO: reducer for success*/
      // state.data = courseInfo;
      state.data = action.payload.data;
    },
    failure(state) {
      state.processing = false;
      /* TODO: reducer for failure*/
    },
    clearData(state) {
      state.processing = false;
      state.data = null;
    },
    updateStatus(state, action) {
      const course = { ...state.data };
      course.status = action.payload.status;
      state.data = course;
    },
  },
});

const { name, actions, reducer } = getDetailsCourseSlice;
const getDetailsCourseAction = createAction(name);
const clearDetailsCourseAction = actions.clearData;

export {
  getDetailsCourseAction,
  clearDetailsCourseAction,
  actions as getDetailsCourseActions,
  reducer as getDetailsCourseReducer,
};
